import type { ComponentIntrinsicElement, FN } from '../types'
import { document as doc } from '../components/ssr.obj'
declare const via

function getCreators() {
    // Browser environment
    if (typeof via !== 'undefined') {
        const document = via.document
        // Check if document exists and has the required methods before trying to use them
        if (typeof document !== 'undefined' && document !== null &&
            typeof document.createComment === 'function' &&
            typeof document.createElement === 'function' &&
            typeof document.createTextNode === 'function' &&
            typeof document.createDocumentFragment === 'function') {
            return {
                createComment: document.createComment as any as FN<[any], Comment>,
                createHTMLNode: document.createElement as any as FN<[ComponentIntrinsicElement], HTMLElement>,
                createSVGNode: ((name: string) => document.createElementNS('http://www.w3.org/2000/svg', name)) as any as FN<[ComponentIntrinsicElement], SVGElement>,
                createText: document.createTextNode as any as FN<[any], Text>,
                createDocumentFragment: document.createDocumentFragment as any as FN<[], DocumentFragment>
            }
        }
    }

    let document = globalThis.document
    if (!document)
        document = doc as any

    // Standard browser/SSR environment - document should be available now
    // Since document is always patched in SSR (see ssr.obj.ts lines 501-502), 
    // we can directly bind its methods without additional checks
    return {
        createComment: document.createComment.bind(document, '') as FN<[any], Comment>,
        createHTMLNode: document.createElement.bind(document) as FN<[ComponentIntrinsicElement], HTMLElement>,
        createSVGNode: document.createElementNS.bind(document, 'http://www.w3.org/2000/svg') as FN<[ComponentIntrinsicElement], Element>,
        createText: document.createTextNode.bind(document) as FN<[any], Text>,
        createDocumentFragment: document.createDocumentFragment.bind(document) as FN<[], DocumentFragment>
    }
}

const { createComment, createHTMLNode, createSVGNode, createText, createDocumentFragment } = getCreators()

/* EXPORT */

export { createComment, createHTMLNode, createSVGNode, createText, createDocumentFragment }